<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M23 3H9a2 2 0 00-2 2v22a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 24H9V5h14z"/><path d="M10.86 15h10.28a.36.36 0 00.36-.36V6.86a.36.36 0 00-.36-.36H10.86a.36.36 0 00-.36.36v7.78a.36.36 0 00.36.36zm.64-7.5h9V14h-9zM10.84 25.5h10.32a.34.34 0 00.34-.34v-6.82a.34.34 0 00-.34-.34H10.84a.34.34 0 00-.34.34v6.82a.34.34 0 00.34.34zm.66-6.5h9v5.5h-9zM20.75 16h-1.5a.5.5 0 000 1h1.5a.5.5 0 000-1z"/></svg>